'use strict';

var _ = require('lodash');
var ChartSponsorForecastFlightController = function ChartSponsorForecastFlightController($scope, $filter, dataProviderService, dataBoundsService, momentService) {
  var defaultSelectionSize = 30;
  var rmMomentFormat = $filter('rmMomentFormat');
  function resetChartControls(businessId) {
    var currentTime = momentService.now(momentService.FIELD.DEPARTURE_TIME).startOf('day');
    $scope.selectedBusinessId = '';
    $scope.selectedFlightSummary = '';
    $scope.time = {
      from: currentTime,
      to: currentTime.add(1, 'days').subtract(1, 'minutes')
    };
    if (businessId !== undefined) {
      $scope.selectedBusinessId = businessId;
      $scope.initChart();
    }
  }
  $scope.resetChart = function () {
    resetChartControls();
    $scope.initChart();
  };
  $scope.metricLabels = ['ignore'];
  $scope.initChart = function () {
    $scope.flight = null;
    if (_.isEmpty($scope.leg)) {
      return false;
    }
    dataProviderService.getData($scope.leg).then(function (chartData) {
      $scope.data = chartData.data;
      $scope.legend = _.orderBy(chartData.legend, 'label', 'desc');
      var departureDateBounds = dataBoundsService.getDateBounds($scope.data);
      $scope.time.from = departureDateBounds.min;
      $scope.time.to = departureDateBounds.max;
      if ($scope.selectedBusinessId) {
        setSelection($scope.selectedBusinessId);
      } else {
        renderChart(defaultSelectionSize);
      }
      $scope.$emit('sponsor-forecast-flight', $scope.data ? $scope.data.length : false);
    }, function () {
      $scope.$emit('sponsor-forecast-flight', false);
    });
  };
  function renderChart(selectionSize) {
    $scope.renderChart($scope.data, selectionSize);
  }
  $scope.chartFormatters = {
    xAxisTickFormatter: function xAxisTickFormatter(d, i) {
      var format = i % 4 === 0 ? 'DAY_MONTH_SHORT_NAME' : 'DAY_OF_MONTH';
      return rmMomentFormat(d, format);
    },
    yAxisTickFormatter: function yAxisTickFormatter(d) {
      return rmMomentFormat(momentService.of(d.valueOf(), momentService.FIELD.DEPARTURE_TIME), 'TIME_USER_SETTINGS');
    }
  };
  function getTimeString(date) {
    return rmMomentFormat(date, 'TIME_USER_SETTINGS');
  }
  function setSelectedFlightSummary(selectedFlights, minDepartureDate, maxDepartureDate) {
    var timeString = minDepartureDate === maxDepartureDate ? getTimeString(minDepartureDate) : getTimeString(minDepartureDate) + ' - ' + getTimeString(maxDepartureDate);
    $scope.selectedFlightSummary = timeString + ' (' + _.keys(selectedFlights).join(', ') + ')';
  }
  function setSelectedFlightData(legBusinessId) {
    var minMaxTimes = dataBoundsService.getMinMaxTimes($scope.data, legBusinessId);
    $scope.flight = {
      legBusinessId: legBusinessId,
      minHourMinute: minMaxTimes.min,
      maxHourMinute: minMaxTimes.max
    };
  }
  function setSelection(legBusinessId) {
    var selectedFlights = {};
    var minDepartureDate, maxDepartureDate;
    $scope.data.forEach(function (d) {
      d.flights.forEach(function (f) {
        if (f.legBusinessId === legBusinessId) {
          f.fill = f.originalFill;
          selectedFlights[f.flightId] = true;
          if (!minDepartureDate || minDepartureDate > f.time) {
            minDepartureDate = f.time;
          }
          if (!maxDepartureDate || maxDepartureDate < f.time) {
            maxDepartureDate = f.time;
          }
        } else {
          f.fill = f.blankColor;
          f.className = 'blank';
        }
      });
    });
    $scope.selectedBusinessId = legBusinessId;
    setSelectedFlightSummary(selectedFlights, minDepartureDate, maxDepartureDate);
    setSelectedFlightData(legBusinessId);
    renderChart(defaultSelectionSize);
  }
  $scope.flightSelectionHandler = function (date, selectedFlight) {
    setSelection(selectedFlight.legBusinessId);
  };
  resetChartControls($scope.selectedBusinessId);
};
ChartSponsorForecastFlightController.$inject = ['$scope', '$filter', 'ChartSponsorForecastFlightDataProviderService', 'ChartSponsorForecastFlightDateBoundsService', 'MomentService'];
module.exports = ChartSponsorForecastFlightController;